var _g, _clipPath, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBGotoDiscBlack40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph-megaphone-light"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-goto",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.078,19.322c-0,0 -6.28,-6.279 -6.28,-6.279c-0.173,-0.173 -0.412,-0.28 -0.677,-0.28c-0.529,-0 -0.958,0.429 -0.958,0.958c-0,0.264 0.107,0.504 0.28,0.677c0,0 4.385,4.385 4.385,4.385c0.043,0.043 0.056,0.108 0.033,0.165c-0.024,0.057 -0.079,0.094 -0.141,0.094c0,-0 -12.12,-0 -12.12,-0c-0.529,-0 -0.958,0.429 -0.958,0.958c-0,0.529 0.429,0.958 0.958,0.958c-0,0 12.12,0 12.12,0c0.062,0 0.117,0.037 0.141,0.094c0.023,0.057 0.01,0.122 -0.033,0.165c-0,0 -4.385,4.385 -4.385,4.385c-0.173,0.173 -0.28,0.413 -0.28,0.677c-0,0.529 0.429,0.958 0.958,0.958c0.265,0 0.504,-0.107 0.677,-0.28c0,-0 6.28,-6.28 6.28,-6.28c0.173,-0.173 0.28,-0.412 0.28,-0.677c0,-0.265 -0.107,-0.504 -0.28,-0.678Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBGotoDiscBlack40);
export default __webpack_public_path__ + "static/media/iconB-goto-disc-black-40.607f09b9fd8b2aadb595cec6453b35af.svg";
export { ForwardRef as ReactComponent };